const styles = theme => ({
  initiateserviceSect: {
    marginBottom: '16px',
    fontSize: '12px',
    padding: '1rem .5rem',
    '& p': {
      fontSize: '12px',
    },
    '& $Title': {
      fontSize: '14px',
    },
    '&:last-child': {
      borderBottom: '0',
      marginBottom: '0',
    },
    '& $link': {
      fontSize: '12px',
    },
  },
  propertyUnitCard: {
    borderBottom: '1px solid #EBEEF3',
    padding: '1rem .5rem',
  },
  initiateservicedtaile: {
    display: 'grid',
    gridTemplateColumns: 'auto',
    gap: '9px',
    '& img': {
      display: 'none',
    },
  },
  propertyImage: {
    width: '34px',
    height: '36px',
    objectFit: 'cover',
  },

  title: {
    fontSize: '14px',
  },
  textGrayLight: {
    color: theme.palette.primary.darkGrey,
  },
  propertyInfo: {
    color: '#484456',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    '& img': {
      marginInlineEnd: '5px',
      maxWidth: '12px',
    },
  },
  propertyContent: {
    marginInlineStart: '.5rem',
  },
  propertyInfo2: {
    color: '#8C9099',
    '& div:not(:last-of-type)': {
      marginInlineEnd: '.75rem',
    },
  },
  viewAll: {
    color: theme.palette.primary.adgmGreen,
    cursor: 'pointer',
  },
  arrowRight: {
    marginInlineStart: '.55rem',
    display: 'inline-block',
    transform: `${theme.direction === 'rtl' && 'rotate(180deg)'}`,
  },
  modal: {
    overflow: 'hidden',
    outline: 'none',
  },
  propertyModalContainer: {
    maxHeight: '75vh',
    overflow: 'auto',
    borderTop: '1px solid #CED1D6',
    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar': {
      width: '8px',
      borderRadius: '12px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '50rem',
    },
  },
  [theme.breakpoints.up('md')]: {
    propertyUnitCard: {
      padding: '1rem',
      justifyContent: 'space-between',
      alignItems: 'center',
      '& $title': {
        fontSize: '18px',
      },
    },
    initiateserviceSect: {
      fontSize: '16px',
      padding: '1rem',
      '& p': {
        fontSize: '16px',
      },
      '& $Title': {
        fontSize: '20px',
      },
      '& $link': {
        fontSize: '14px',
      },
    },

    initiateservicedtaile: {
      gridTemplateColumns: '61px auto',
      '& img': {
        display: 'block',
      },
    },
    propertyImage: {
      width: '68px',
      height: '72px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    propertyUnitCard: {
      flexDirection: 'column',
    },
    propertyInfo: {
      fontSize: '14px',
    },
    propertyInfoMob: {
      fontSize: '12px',
      color: '#8C9099',
    },
    btnMob: {
      fontSize: '12px',
      '& img': {
        width: '12px',
      },
    },
  },
});

export default styles;
